import type { DialDevice, UserDevice } from "services/dialstack";

// What the user's hardware phone is called in the dialer (ENG-2539). A DECT
// cordless handset (snom M-series, the recommended cordless) is "a desk phone"
// to the platform, not to the person holding it: a front-desk user looking for
// her cordless under "Desk phone" concludes it is missing. "Desk phone" stays
// for a desk phone and for a mix.
export const DESK_PHONE_LABEL = "Desk phone";
export const CORDLESS_PHONE_LABEL = "Cordless phone";

export function dialDeviceLabel(devices: UserDevice[]) {
  return devices.length > 0 &&
    devices.every((device) => device.type === "dect_handset")
    ? CORDLESS_PHONE_LABEL
    : DESK_PHONE_LABEL;
}

// The modifier that flips a click-to-call to the user's other device for one
// call (ENG-2183). Spelled out, not "⌥": most front-desk users have never
// seen the glyph. It is the Option key on a Mac and Alt everywhere else.
export const isMacPlatform = () =>
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad/.test(navigator.platform);

export const dialDeviceModifierLabel = () =>
  isMacPlatform() ? "Option" : "Alt";

// Tooltip for a phone icon: what a plain click does, and how to do the other
// thing. Only when the user actually has a hardware phone; otherwise the
// action alone, as before.
export function dialDeviceTooltip(
  action: string,
  dialDevice: DialDevice,
  devices: UserDevice[]
) {
  if (devices.length === 0) return action;
  const modifier = dialDeviceModifierLabel();
  const phone = dialDeviceLabel(devices).toLowerCase();
  return dialDevice === "deskphone"
    ? `${action} on your ${phone} · hold ${modifier} to call from this computer`
    : `${action} from this computer · hold ${modifier} to ring your ${phone}`;
}
